export default {
  newTaglabel: {
    id: 'product_page_price_new_tag_label',
    defaultMessage: 'Brand new',
  },
  flashSalesTag: {
    id: 'flash_sales_product_card_tag',
    defaultMessage: '{price} off at checkout',
  },
  qualityAssuranceFee: {
    id: 'product_page_price_quality_assurance_fee',
    defaultMessage:
      '{qualityAssuranceFeeLink, html} applies (starting at £0.99)',
  },
}
